import ManagerRepository from 'coreClasses/ManagerRepository';
import {EEventSource, IEventData} from 'coreClasses/events/IEvents';
import {EGoogleTagManagerEventSource} from '../../IGoogleTagManager';
import EventModel from '../EventModel';

/**
 * Represents ECommerceEventModel
 */
export default class ECommerceEventModel extends EventModel {
	private source: string = '';

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {IEventData} data - data
	 */
	constructor(managerRepository: ManagerRepository, data: IEventData) {
		super(managerRepository, data);

		if (data?.source) {
			const eventSource = EGoogleTagManagerEventSource[EEventSource[data.source]];

			this.source = data?.sourceSpecification
				? data.sourceSpecification
				: eventSource;
		} else if (data?.sourceSpecification) {
			this.source = data.sourceSpecification;
		}
	}

	/**
	 * Returns event source
	 * @returns {string} - source
	 */
	getSource() {
		return this.source;
	}
}
